import { render, staticRenderFns } from "./editRules.vue?vue&type=template&id=ad123470&scoped=true&"
import script from "./editRules.vue?vue&type=script&lang=js&"
export * from "./editRules.vue?vue&type=script&lang=js&"
import style0 from "./editRules.vue?vue&type=style&index=0&id=ad123470&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad123470",
  null
  
)

export default component.exports